<template>
  <div>
    <Head :title="`${$t('situationcases.situation_case')} #${data.id}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_details.id}/view`">
        {{ data.applicant_details.name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ data.id }}
    </h1>
    <div class="grid gap-4 lg:grid-cols-2 grid-cols-1">
      <detail-view :data="detailView">
        <template v-slot="item">
          <yes-no class="flex" v-if="item.props.key === 'interned'" :value="!!item.props.value" />
          <div v-if="item.props.key === 'reason_imprisonment'">
            <div v-if="!hideInfo" class="pb-5">
              {{ item.props.value }}
            </div>
            <div class="pb-5w-full">
              <button class="text-gray-600 hover:underline italic" tabindex="-1" type="button" @click="hideInfo = !hideInfo">
                <span v-if="hideInfo">{{ $t('applications.show_reason') }}</span>
                <span v-else>{{ $t('applications.hide_reason') }}</span>
              </button>
            </div>
          </div>
        </template>
      </detail-view>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import YesNo from '@/Shared/YesNo'
import DetailView from '@/Shared/DetailView'

export default {
  components: {
    Head,
    Link,
    YesNo,
    DetailView,
  },
  layout: Layout,
  props: {
    data: Object,
  },
  data() {
    return {
      hideInfo: true,
      detailView: {
        items: [
          { label: this.$t('situationcases.location'), value: this.data.location },
          { label: this.$t('situationcases.date_imprisonment'), value: this.$filters.formatDate(this.data.date_imprisonment)},
          {
            key: 'interned',
            label: this.$t('situationcases.interned'),
            value: this.data.interned,
          },
          {
            key: 'reason_imprisonment',
            label: this.$t('situationcases.reason_imprisonment'),
            value: this.data.reason_imprisonment,
          },
        ],
        updateLink: `/applicants/${this.data.applicant_details.id}/situation-cases/${this.data.id}/edit/`,
        header: {
          title: this.$t('situationcases.title'),
          text: this.$t('situationcases.text'),
        },
      },
    }
  },
}
</script>
